import React, { useState, useEffect, useCallback, useMemo } from 'react';
import grupoAcessoService from '../../services/grupoAcesso.service';
import rotinaService       from '../../services/rotina.service';        // r84: catálogo + permissões dinâmicas
import BtnIcone from '../../components/BtnIcone';
import SePode from '../../components/SePode';   // r88: botões condicionais por permissão
import Modal from '../../components/Modal';
import BrowseHeader from '../../components/BrowseHeader';   // r135: header padronizado
import { useAuth } from '../../context/AuthContext';
import { iconeDaRotina } from '../../constants/iconesRotinas';   // r134: SVGs idênticos ao Sidebar

// ─── Paleta ───────────────────────────────────────────────────────────────────
const COR = {
  azul:     '#003399',
  azulBg:   '#eff6ff',
  borda:    '#e8eaed',
  texto:    '#1a1a2e',
  muted:    '#888',
  branco:   '#fff',
  verde:    '#1D9E75',
  verdeBg:  '#f0fff4',
  amarelo:  '#d97706',
  amareloBg:'#fef3c7',
  vermelho: '#e53935',
  vermBg:   '#fff0f0',
  cinzaBg:  '#fafbfc',
};

// ─── r133: SVGs ───────────────────────────────────────────────────────────────
// Chevron do combo (mesmo padrão pra abrir/fechar seções)
const SvgChevron = ({ size = 14, color = 'currentColor', aberto }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color}
       strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
       style={{
         transform: aberto ? 'rotate(180deg)' : 'rotate(0deg)',
         transition: 'transform 0.15s',
       }}>
    <polyline points="6 9 12 15 18 9"/>
  </svg>
);

// SVGs das seções principais (Dados Cadastrais / Permissões)
const SvgDados = ({ size = 18, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color}
       strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
    <polyline points="14 2 14 8 20 8"/>
    <line x1="8" y1="13" x2="16" y2="13"/>
    <line x1="8" y1="17" x2="16" y2="17"/>
  </svg>
);
const SvgPermissoes = ({ size = 18, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color}
       strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
    <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
  </svg>
);

// r133 item 7: ícones por grupo de permissões (mesmos do menu lateral)
// As chaves são as seções vindas do backend (normalizadas pra UPPER).
const ICONES_SECAO = {
  PRINCIPAL: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <rect x="1" y="1" width="6" height="6" rx="1" fill="currentColor"/>
      <rect x="9" y="1" width="6" height="6" rx="1" fill="currentColor" opacity=".5"/>
      <rect x="1" y="9" width="6" height="6" rx="1" fill="currentColor" opacity=".5"/>
      <rect x="9" y="9" width="6" height="6" rx="1" fill="currentColor" opacity=".5"/>
    </svg>
  ),
  CADASTROS: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <rect x="2" y="3" width="12" height="11" rx="1.5" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M5 6h6M5 9h6M5 12h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  ),
  COMERCIAL: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M2 12L6 8l3 3 5-6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  'TÉCNICA': (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <rect x="1.5" y="2.5" width="9" height="11" rx="1" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M3.5 5.5h5M3.5 8h5M3.5 10.5h3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      <circle cx="12.5" cy="11.5" r="2.5" stroke="currentColor" strokeWidth="1.5"/>
    </svg>
  ),
  TECNICA: (    // alias sem acento (caso o backend devolva sem)
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <rect x="1.5" y="2.5" width="9" height="11" rx="1" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M3.5 5.5h5M3.5 8h5M3.5 10.5h3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      <circle cx="12.5" cy="11.5" r="2.5" stroke="currentColor" strokeWidth="1.5"/>
    </svg>
  ),
  TAREFAS: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <rect x="2" y="2" width="12" height="12" rx="1.5" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M5 8l2 2 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  SISTEMA: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <circle cx="8" cy="8" r="2" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M8 1v2M8 13v2M1 8h2M13 8h2M3.5 3.5l1.4 1.4M11.1 11.1l1.4 1.4M3.5 12.5l1.4-1.4M11.1 4.9l1.4-1.4"
            stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  ),
  OUTROS: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <circle cx="8" cy="8" r="6" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M5 8h6M8 5v6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  ),
};

// Normaliza a label da seção pra Title Case (Cadastros, Comercial, Técnica…)
function tituloSecao(sec) {
  if (!sec) return 'Outros';
  const s = sec.toString().toLowerCase();
  return s.charAt(0).toUpperCase() + s.slice(1);
}
// Retorna o ícone correspondente à seção (independente de acento/case)
function iconeSecao(sec) {
  if (!sec) return ICONES_SECAO.OUTROS;
  const k = sec.toString().toUpperCase();
  return ICONES_SECAO[k] || ICONES_SECAO.OUTROS;
}

// ─── r133: Secao expansível (padrão dos cadastros novos: Colaborador, Negócios) ──
function Secao({ icone, titulo, aberta, onToggle, children, fixa }) {
  const Icone = typeof icone === 'function' ? icone : null;
  const elemIcone = Icone
    ? <Icone size={18} />
    : icone; // se for JSX direto (caso dos grupos de permissões)
  const estaAberta = fixa ? true : aberta;
  return (
    <div style={{
      border: `1px solid ${COR.borda}`, borderRadius: '6px',
      marginBottom: '12px', overflow: 'hidden', backgroundColor: COR.branco,
    }}>
      <div
        onClick={fixa ? undefined : onToggle}
        style={{
          padding: '12px 16px',
          backgroundColor: estaAberta ? COR.azulBg : COR.cinzaBg,
          borderBottom: estaAberta ? `1px solid ${COR.borda}` : 'none',
          cursor: fixa ? 'default' : 'pointer',
          userSelect: 'none',
          display: 'flex', alignItems: 'center', gap: '10px',
          transition: 'background-color 0.15s',
        }}
      >
        {elemIcone && (
          <span style={{ display: 'inline-flex', color: estaAberta ? COR.azul : COR.muted }}>
            {elemIcone}
          </span>
        )}
        <span style={{
          flex: 1,
          fontSize: '14px',
          fontWeight: '700',
          color: estaAberta ? COR.azul : COR.texto,
        }}>
          {titulo}
        </span>
        {!fixa && (
          <span style={{ display: 'inline-flex', color: COR.muted }}>
            <SvgChevron aberto={estaAberta} size={16} />
          </span>
        )}
      </div>
      {estaAberta && <div style={{ padding: '16px' }}>{children}</div>}
    </div>
  );
}

// ─── Status Pill ──────────────────────────────────────────────────────────────
// r133 item 9: padrão Colaborador (12/500, borda na cor da fonte)
function StatusPill({ status }) {
  const ativo = status === 'A';
  const cor = ativo ? COR.verde : COR.amarelo;
  return (
    <span style={{
      display: 'inline-block', padding: '2px 10px',
      borderRadius: '20px', fontSize: '12px', fontWeight: '500',
      backgroundColor: ativo ? COR.verdeBg : COR.amareloBg,
      color: cor,
      border: `1px solid ${cor}`,
    }}>{ativo ? 'Ativo' : 'Inativo'}</span>
  );
}

// ─── Campo do formulário ──────────────────────────────────────────────────────
function Campo({ label, children, obrigatorio }) {
  return (
    <div style={{ marginBottom: '0' }}>
      <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: COR.muted, marginBottom: '2px' }}>
        {label}{obrigatorio && <span style={{ color: COR.vermelho }}> *</span>}
      </label>
      {children}
    </div>
  );
}

const inputStyle = {
  width: '100%', height: '36px', padding: '0 10px',
  border: `1px solid ${COR.borda}`, borderRadius: '5px',
  fontSize: '13px', boxSizing: 'border-box',
  backgroundColor: COR.branco, color: COR.texto, outline: 'none',
  fontFamily: "'Manrope', sans-serif",
};

// r84: CheckPerm removido — substituído pelos checkboxes dentro dos RotinaCard

// ─── Componente principal ─────────────────────────────────────────────────────
function GruposAcessoPage() {
  const [grupos, setGrupos]         = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [busca, setBusca]           = useState('');
  const [ordenacao, setOrdenacao]   = useState({ campo: 'descricao', dir: 'asc' });

  // Painel
  const [painel, setPainel]           = useState(null); // null | 'novo' | 'editar' | 'visualizar'
  const [selecionado, setSelecionado] = useState(null);
  // r133: abas removidas (Dados Cadastrais e Permissões agora são seções na mesma tela)
  const [salvando, setSalvando]       = useState(false);
  const [erroPainel, setErroPainel]   = useState('');
  const [sucessoPainel, setSucessoPainel] = useState('');

  // Formulário dados cadastrais
  const [form, setForm] = useState({ descricao: '', perfil: '', status: 'A' });

  // r84: contexto de auth (pra usuario_id no salvar)
  const { usuario } = useAuth();

  // r84: catálogo de rotinas (carregado UMA vez do backend)
  const [catalogoRotinas, setCatalogoRotinas] = useState([]);
  const [carregandoCatalogo, setCarregandoCatalogo] = useState(false);

  // r84: configuração de permissões do grupo selecionado
  //   permConfig[rotina_codigo][acao_codigo] = { permitido, filtro_proprio }
  const [permConfig, setPermConfig] = useState({});
  const [permBootstrap, setPermBootstrap] = useState(false);
  const [carregandoPerm, setCarregandoPerm] = useState(false);
  const [salvandoPerm, setSalvandoPerm] = useState(false);
  const [filtroRotinas, setFiltroRotinas] = useState('');
  const [rotinasExpandidas, setRotinasExpandidas] = useState(new Set());
  // r133: estado de expansão dos GRUPOS de permissão (Cadastros, Comercial...).
  // Começam todos fechados.
  const [gruposExpandidos, setGruposExpandidos] = useState(new Set());
  const toggleGrupo = (sec) => setGruposExpandidos(prev => {
    const novo = new Set(prev);
    if (novo.has(sec)) novo.delete(sec);
    else novo.add(sec);
    return novo;
  });

  // ── Carregar ─────────────────────────────────────────────────────────────────
  const carregar = useCallback(async () => {
    try {
      setCarregando(true);
      const lista = await grupoAcessoService.listar();
      setGrupos(lista);
    } catch {
      // Dados de exemplo enquanto o backend não existir
      setGrupos([
        { id: '000001', descricao: 'Administrador', perfil: 'ADM', status: 'A' },
        { id: '000002', descricao: 'Colaborador',   perfil: 'COL', status: 'A' },
        { id: '000003', descricao: 'Cliente Gestor',perfil: 'CLI', status: 'A' },
      ]);
    } finally {
      setCarregando(false);
    }
  }, []);

  useEffect(() => { carregar(); }, [carregar]);

  // r84: carrega catálogo de rotinas (uma vez quando o painel abre)
  useEffect(() => {
    if (!painel || catalogoRotinas.length > 0) return;
    let cancel = false;
    (async () => {
      try {
        setCarregandoCatalogo(true);
        const rs = await rotinaService.listar();
        if (!cancel) setCatalogoRotinas(rs || []);
      } catch (err) {
        if (!cancel) setErroPainel('Erro ao carregar catálogo de rotinas: ' + (err.response?.data?.mensagem || err.message));
      } finally {
        if (!cancel) setCarregandoCatalogo(false);
      }
    })();
    return () => { cancel = true; };
  }, [painel, catalogoRotinas.length]);

  // r84: carrega permissões do grupo selecionado quando muda
  useEffect(() => {
    if (!selecionado?.id) {
      setPermConfig({});
      setPermBootstrap(false);
      return;
    }
    let cancel = false;
    (async () => {
      try {
        setCarregandoPerm(true);
        const p = await rotinaService.lerPermissoes(selecionado.id);
        if (cancel) return;
        setPermConfig(p?.permissoes || {});
        setPermBootstrap(!!p?.bootstrap);
      } catch (err) {
        if (!cancel) setErroPainel('Erro ao carregar permissões: ' + (err.response?.data?.mensagem || err.message));
      } finally {
        if (!cancel) setCarregandoPerm(false);
      }
    })();
    return () => { cancel = true; };
  }, [selecionado?.id]);

  // ── Filtro e ordenação ───────────────────────────────────────────────────────
  const gruposFiltrados = grupos
    .filter(g => {
      const q = busca.toLowerCase();
      return !q || g.descricao.toLowerCase().includes(q) || (g.perfil || '').toLowerCase().includes(q);
    })
    .sort((a, b) => {
      const va = (a[ordenacao.campo] || '').toLowerCase();
      const vb = (b[ordenacao.campo] || '').toLowerCase();
      return ordenacao.dir === 'asc' ? va.localeCompare(vb) : vb.localeCompare(va);
    });

  const toggleOrdem = (campo) =>
    setOrdenacao(o => ({ campo, dir: o.campo === campo && o.dir === 'asc' ? 'desc' : 'asc' }));

  const setaCabecalho = (campo) => {
    if (ordenacao.campo !== campo) return ' ↕';
    return ordenacao.dir === 'asc' ? ' ↑' : ' ↓';
  };

  // ── Ações do painel ──────────────────────────────────────────────────────────
  const abrirNovo = () => {
    setForm({ descricao: '', perfil: '', status: 'A' });
    setPermConfig({});                                 // r84: zera permissões
    setPermBootstrap(false);
    setRotinasExpandidas(new Set());
    setSelecionado(null);
    setErroPainel(''); setSucessoPainel('');
    setPainel('novo');
  };

  const abrirVisualizar = (g) => {
    // r84: useEffect cuida de carregar permissões quando selecionado muda
    setSelecionado(g);
    setForm({ descricao: g.descricao, perfil: g.perfil, status: g.status });
    setRotinasExpandidas(new Set());
    setErroPainel(''); setSucessoPainel('');
    setPainel('visualizar');
  };

  const abrirEditar = (g) => {
    setSelecionado(g);
    setForm({ descricao: g.descricao, perfil: g.perfil, status: g.status });
    setRotinasExpandidas(new Set());
    setErroPainel(''); setSucessoPainel('');
    setPainel('editar');
  };

  const fecharPainel = () => { setPainel(null); setSelecionado(null); };

  const handleCampo = (e) => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  // r84: handlePermissao e toggleColuna antigos foram removidos.
  // A configuração de permissões agora é feita via permConfig e helpers abaixo.

  // ── Helpers de permissões dinâmicas (r84) ──────────────────────────────
  const getPerm = (rotinaCod, acaoCod) =>
    permConfig[rotinaCod]?.[acaoCod] || { permitido: false, filtro_proprio: null };

  const setPerm = (rotinaCod, acaoCod, novaPerm) => {
    setPermConfig(prev => {
      const next = { ...prev };
      if (!next[rotinaCod]) next[rotinaCod] = {};
      next[rotinaCod] = { ...next[rotinaCod], [acaoCod]: novaPerm };
      return next;
    });
  };

  // Filtro é POR ROTINA (não por ação). Aplica o mesmo filtro a todas as ações.
  const getFiltroDaRotina = (rotinaCod) => {
    const acoes = permConfig[rotinaCod] || {};
    for (const a of Object.values(acoes)) {
      if (a.filtro_proprio) return a.filtro_proprio;
    }
    return null;
  };

  const setFiltroDaRotina = (rotinaCod, filtroCod) => {
    setPermConfig(prev => {
      const next = { ...prev };
      const acoesAtuais = { ...(next[rotinaCod] || {}) };
      const rotinaDef = catalogoRotinas.find(r => r.codigo === rotinaCod);
      rotinaDef?.acoes.forEach(a => {
        if (!acoesAtuais[a.codigo]) acoesAtuais[a.codigo] = { permitido: false };
      });
      Object.keys(acoesAtuais).forEach(ac => {
        acoesAtuais[ac] = { ...acoesAtuais[ac], filtro_proprio: filtroCod || null };
      });
      next[rotinaCod] = acoesAtuais;
      return next;
    });
  };

  const setTodasAcoesDaRotina = (rotinaCod, permitido) => {
    const rotinaDef = catalogoRotinas.find(r => r.codigo === rotinaCod);
    if (!rotinaDef) return;
    setPermConfig(prev => {
      const next = { ...prev };
      const acoes = { ...(next[rotinaCod] || {}) };
      rotinaDef.acoes.forEach(a => {
        acoes[a.codigo] = { ...(acoes[a.codigo] || {}), permitido };
      });
      next[rotinaCod] = acoes;
      return next;
    });
  };

  const toggleExpansaoRotina = (rotinaCod) => {
    setRotinasExpandidas(prev => {
      const next = new Set(prev);
      if (next.has(rotinaCod)) next.delete(rotinaCod);
      else next.add(rotinaCod);
      return next;
    });
  };

  // Garante que o grupo exista no banco antes de salvar permissões. Se for
  // novo, cria automaticamente e retorna o id. Caso contrário retorna o id
  // do selecionado. Lança erro se faltar campo obrigatório.
  const garantirGrupoExistente = async () => {
    if (selecionado?.id) return selecionado.id;

    // Grupo não existe ainda: precisa criar
    if (!form.descricao.trim()) throw new Error('Preencha a Descrição antes de configurar permissões.');
    if (!form.perfil.trim())    throw new Error('Preencha o Perfil antes de configurar permissões.');

    const res = await grupoAcessoService.incluir(form);
    const novoId = res?.id;
    if (!novoId) throw new Error('Erro ao criar grupo automaticamente.');
    const novoGrupo = { ...form, id: novoId };
    setSelecionado(novoGrupo);
    setPainel('editar');                  // deixa de ser 'novo'
    await carregar();                      // refresh do browse
    return novoId;
  };

  const salvarPermissoesDaRotina = async (rotinaCod) => {
    setErroPainel(''); setSucessoPainel('');
    try {
      setSalvandoPerm(true);
      const id = await garantirGrupoExistente();
      await rotinaService.salvarPermissoes(id, {
        rotina_codigo: rotinaCod,
        permissoes: permConfig[rotinaCod] || {},
        usuario_id: usuario?.id,
      });
      setPermBootstrap(false);   // backend remove o bootstrap
      setSucessoPainel('Permissões da rotina salvas.');
      setTimeout(() => setSucessoPainel(''), 2500);
    } catch (err) {
      setErroPainel(err.response?.data?.mensagem || err.message || 'Erro ao salvar permissões.');
    } finally {
      setSalvandoPerm(false);
    }
  };

  const salvarTodasPermissoes = async () => {
    setErroPainel(''); setSucessoPainel('');
    try {
      setSalvandoPerm(true);
      const id = await garantirGrupoExistente();
      const rotinasComConfig = Object.keys(permConfig);
      if (rotinasComConfig.length === 0) {
        setSucessoPainel('Nenhuma alteração nas permissões.');
        setTimeout(() => setSucessoPainel(''), 2000);
        return;
      }
      let ok = 0;
      for (const rcod of rotinasComConfig) {
        await rotinaService.salvarPermissoes(id, {
          rotina_codigo: rcod,
          permissoes: permConfig[rcod] || {},
          usuario_id: usuario?.id,
        });
        ok++;
      }
      setPermBootstrap(false);
      setSucessoPainel(`${ok} rotina(s) salvas.`);
      setTimeout(() => setSucessoPainel(''), 3000);
    } catch (err) {
      setErroPainel(err.response?.data?.mensagem || err.message || 'Erro ao salvar permissões.');
    } finally {
      setSalvandoPerm(false);
    }
  };

  // Filtragem visual por texto + agrupamento por seção
  const rotinasVisiveis = useMemo(() => {
    if (!filtroRotinas.trim()) return catalogoRotinas;
    const q = filtroRotinas.toLowerCase();
    return catalogoRotinas.filter(r =>
      r.label.toLowerCase().includes(q) ||
      (r.secao || '').toLowerCase().includes(q) ||
      r.codigo.toLowerCase().includes(q)
    );
  }, [catalogoRotinas, filtroRotinas]);

  const rotinasPorSecao = useMemo(() => {
    const m = new Map();
    rotinasVisiveis.forEach(r => {
      const sec = r.secao || 'OUTROS';
      if (!m.has(sec)) m.set(sec, []);
      m.get(sec).push(r);
    });
    // r168b: aninha visualmente cada 'valores-<pai>' logo abaixo do seu <pai>
    // (ex.: valores-clientes vem logo depois de clientes). Só reordenação de
    // exibição — não muda nada no catálogo/backend.
    for (const [sec, lista] of m) {
      const filhos = lista.filter(r => r.codigo.startsWith('valores-'));
      const base   = lista.filter(r => !r.codigo.startsWith('valores-'));
      const ordenada = [];
      base.forEach(r => {
        ordenada.push(r);
        const filho = filhos.find(f => f.codigo === `valores-${r.codigo}`);
        if (filho) ordenada.push(filho);
      });
      // valores cujo pai não está visível (ex.: filtro de texto) vão pro fim
      filhos.forEach(f => { if (!ordenada.includes(f)) ordenada.push(f); });
      m.set(sec, ordenada);
    }
    return m;
  }, [rotinasVisiveis]);

  // ── Salvar dados cadastrais ──────────────────────────────────────────────────
  // r84: este botão agora salva APENAS dados do grupo (descrição/perfil/status).
  //      Permissões têm seus próprios botões dentro da aba (por rotina ou tudo).
  const salvar = async () => {
    setErroPainel(''); setSucessoPainel('');
    if (!form.descricao.trim()) return setErroPainel('Descrição é obrigatória.');
    if (!form.perfil.trim())    return setErroPainel('Perfil é obrigatório.');

    try {
      setSalvando(true);
      if (painel === 'novo') {
        const res = await grupoAcessoService.incluir(form);
        setSelecionado({ ...form, id: res.id });
        setPainel('editar');
        setSucessoPainel('Grupo incluído. Configure as permissões na aba ao lado.');
      } else {
        await grupoAcessoService.alterar(selecionado.id, form);
        setSucessoPainel('Grupo alterado com sucesso!');
        setTimeout(fecharPainel, 1200);
      }
      await carregar();
    } catch (err) {
      setErroPainel(err.response?.data?.mensagem || 'Erro ao salvar. Verifique os dados.');
    } finally {
      setSalvando(false);
    }
  };

  // ─── Render ──────────────────────────────────────────────────────────────────
  const somenteLeitura = painel === 'visualizar';

  return (
    <div style={{ fontFamily: "'Manrope', sans-serif" }}>

      {/* r135: BrowseHeader padronizado (igual UsuariosPage) */}
      <BrowseHeader
        rotina="grupos-acesso"
        titulo="Grupos de Acesso"
        descricao="Configuração de grupos de acesso e suas permissões por rotina do sistema."
      />

      {/* ── BROWSE ── */}
      <div style={{
        flex: 1, backgroundColor: COR.branco,
        border: `1px solid ${COR.borda}`, borderRadius: '8px',
        overflow: 'hidden', minWidth: 0,
      }}>
        {/* Cabeçalho do browse — r135: só contagem + busca + botão (sem título redundante) */}
        <div style={{
          padding: '14px 16px', borderBottom: `1px solid ${COR.borda}`,
          display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap',
        }}>
          <span style={{ fontSize: '13px', fontWeight: '500', color: COR.muted, flex: 1 }}>
            {gruposFiltrados.length} registro{gruposFiltrados.length !== 1 ? 's' : ''}
          </span>
          <input
            type="text"
            placeholder="Pesquisar..."
            value={busca}
            onChange={e => setBusca(e.target.value)}
            style={{ ...inputStyle, width: '320px' }}
          />
          <SePode rotina="grupos-acesso" acao="incluir">
            <BtnIcone icone="incluir" onClick={abrirNovo} title="Incluir novo grupo" cor={COR.azul} solido tamanho="grande" />
          </SePode>
        </div>

        {/* Tabela */}
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
            <thead>
              <tr style={{ backgroundColor: COR.azul }}>
                {/* r135: 1ª coluna fixa pro ícone SVG da rotina */}
                <th style={{ padding: '10px 14px', width: '36px' }}></th>
                {[
                  { label: 'Descrição', campo: 'descricao' },
                  { label: 'Perfil',    campo: 'perfil'    },
                  { label: 'Status',    campo: 'status'    },
                  { label: 'Ações',     campo: null        },
                ].map(({ label, campo }) => (
                  <th key={label} onClick={() => campo && toggleOrdem(campo)} style={{
                    padding: '10px 14px', textAlign: 'left',
                    fontSize: '13px', fontWeight: '700',
                    color: COR.branco, whiteSpace: 'nowrap',
                    cursor: campo ? 'pointer' : 'default', userSelect: 'none',
                  }}>
                    {label}{campo && setaCabecalho(campo)}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {carregando ? (
                <tr><td colSpan="5" style={{ padding: '40px', textAlign: 'center', color: COR.muted }}>Carregando...</td></tr>
              ) : gruposFiltrados.length === 0 ? (
                <tr><td colSpan="5" style={{ padding: '40px', textAlign: 'center', color: COR.muted }}>Nenhum grupo encontrado.</td></tr>
              ) : gruposFiltrados.map((g, i) => (
                <tr key={g.id}
                  onClick={() => abrirVisualizar(g)}
                  style={{
                    borderBottom: `1px solid ${COR.borda}`,
                    backgroundColor: selecionado?.id === g.id ? COR.azulBg : i % 2 === 0 ? COR.branco : '#fafafa',
                    cursor: 'pointer',
                  }}
                >
                  {/* r135: ícone SVG #003399 da rotina (mesmo do menu lateral) */}
                  <td style={{ padding: '10px 0 10px 14px', verticalAlign: 'middle' }}>
                    {iconeDaRotina('grupos-acesso', { width: 20, height: 20, color: COR.azul })}
                  </td>
                  <td style={{ padding: '10px 14px', fontWeight: '500', color: COR.texto }}>{g.descricao}</td>
                  <td style={{ padding: '10px 14px', color: COR.muted }}>{g.perfil}</td>
                  <td style={{ padding: '10px 14px' }}><StatusPill status={g.status} /></td>
                  <td style={{ padding: '10px 14px' }}>
                    <div style={{ display: 'flex', gap: '4px' }} onClick={e => e.stopPropagation()}>
                      <SePode rotina="grupos-acesso" acao="alterar"><BtnIcone icone="alterar"     onClick={() => abrirEditar(g)}    title="Alterar"      cor={COR.azul}     /></SePode>
                      <SePode rotina="grupos-acesso" acao="configurar-permissoes"><BtnIcone icone="permissoes"  onClick={() => abrirEditar(g)} title="Permissões" cor="#7c3aed"      /></SePode>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* ── MODAL ── */}
      <Modal
        aberto={!!painel}
        titulo={painel === 'novo' ? 'Novo Grupo' : painel === 'editar' ? 'Alterar Grupo' : 'Visualizar Grupo'}
        onFechar={fecharPainel}
        onSalvar={salvar}
        salvando={salvando}
        somenteLeitura={somenteLeitura}
        onEditar={() => setPainel('editar')}
        // r133 item 1: header rico (faixa azul, ícone SVG, descrição, botões no topo)
        rotina="grupos-acesso"
        descricao="Configuração de grupos de acesso e suas permissões por rotina do sistema."
        botoesNoTopo={true}
        largura="95vw"
      >
        <div>


            {erroPainel && (
              <div style={{ backgroundColor: COR.vermBg, border: `1px solid #ffcccc`, borderRadius: '5px', color: COR.vermelho, fontSize: '13px', padding: '10px 12px', marginBottom: '14px' }}>
                {erroPainel}
              </div>
            )}
            {sucessoPainel && (
              <div style={{ backgroundColor: COR.verdeBg, border: `1px solid #a8e6c1`, borderRadius: '5px', color: '#1d6a3a', fontSize: '13px', padding: '10px 12px', marginBottom: '14px' }}>
                {sucessoPainel}
              </div>
            )}

            {/* ═══ r133 itens 2 e 3: seções fixas (sem abas) ═══ */}

            {/* ── SEÇÃO DADOS CADASTRAIS (fixa) ─────────────────────── */}
            <Secao icone={SvgDados} titulo="Dados Cadastrais" fixa>
              {/* r133 item 3: Descrição | Perfil | Status em uma linha */}
              <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr', gap: '10px' }}>
                <Campo label="Descrição" obrigatorio>
                  <input name="descricao" value={form.descricao} onChange={handleCampo} disabled={somenteLeitura} style={inputStyle} placeholder="Ex: Administrador" />
                </Campo>
                <Campo label="Perfil" obrigatorio>
                  <select name="perfil" value={form.perfil} onChange={handleCampo} disabled={somenteLeitura} style={{ ...inputStyle, cursor: somenteLeitura ? 'default' : 'pointer' }}>
                    <option value="">Selecione...</option>
                    <option value="Administrador">Administrador</option>
                    <option value="Colaborador">Colaborador</option>
                    <option value="Cliente">Cliente</option>
                  </select>
                </Campo>
                <Campo label="Status" obrigatorio>
                  <select name="status" value={form.status} onChange={handleCampo} disabled={somenteLeitura} style={{ ...inputStyle, cursor: somenteLeitura ? 'default' : 'pointer' }}>
                    <option value="A">Ativo</option>
                    <option value="I">Inativo</option>
                  </select>
                </Campo>
              </div>
            </Secao>

            {/* ── SEÇÃO PERMISSÕES (fixa) ───────────────────────────── */}
            <Secao icone={SvgPermissoes} titulo="Permissões" fixa>
              <div>
                {/* r133 item 8: removida a <p> descritiva repetitiva */}

                {/* Banner de bootstrap */}
                {permBootstrap && selecionado?.id && (
                  <div style={{
                    padding: '10px 12px', backgroundColor: COR.amareloBg,
                    border: `1px solid ${COR.amarelo}`,
                    borderRadius: '5px', marginBottom: '12px',
                    color: COR.amarelo, fontSize: '12px', fontWeight: '600',
                  }}>
                    ⚠ Este grupo está em <strong>modo bootstrap</strong> — todas as rotinas
                    estão liberadas automaticamente. Ao salvar a primeira configuração, esse
                    modo desliga e somente as permissões marcadas serão aplicadas.
                  </div>
                )}

                {/* Banner pra grupo novo */}
                {painel === 'novo' && !selecionado?.id && (
                  <div style={{
                    padding: '10px 12px', backgroundColor: COR.azulBg,
                    border: `1px solid ${COR.azul}`,
                    borderRadius: '5px', marginBottom: '12px',
                    color: COR.azul, fontSize: '12px',
                  }}>
                    ℹ Você está criando um grupo novo. Ao salvar a primeira permissão
                    aqui (ou clicar em "Salvar tudo"), o grupo será criado automaticamente
                    com os dados da aba "Dados Cadastrais".
                  </div>
                )}

                {/* Toolbar: filtro + expandir/recolher + salvar tudo */}
                <div style={{
                  display: 'flex', gap: '8px', alignItems: 'center',
                  flexWrap: 'wrap', marginBottom: '12px',
                }}>
                  <input
                    type="text" placeholder="Filtrar rotinas..."
                    value={filtroRotinas} onChange={e => setFiltroRotinas(e.target.value)}
                    style={{ ...inputStyle, flex: 1, minWidth: '200px' }}
                  />
                  <button type="button"
                    onClick={() => setRotinasExpandidas(new Set(catalogoRotinas.map(r => r.codigo)))}
                    style={{
                      padding: '7px 12px', fontSize: '12px',
                      backgroundColor: COR.branco, color: COR.azul,
                      border: `1px solid ${COR.azul}`, borderRadius: '4px',
                      cursor: 'pointer', fontWeight: '600',
                    }}>
                    Expandir todas
                  </button>
                  <button type="button"
                    onClick={() => setRotinasExpandidas(new Set())}
                    style={{
                      padding: '7px 12px', fontSize: '12px',
                      backgroundColor: COR.branco, color: COR.muted,
                      border: `1px solid ${COR.borda}`, borderRadius: '4px',
                      cursor: 'pointer', fontWeight: '600',
                    }}>
                    Recolher todas
                  </button>
                  {!somenteLeitura && (
                    <button type="button"
                      onClick={salvarTodasPermissoes} disabled={salvandoPerm || carregandoCatalogo}
                      style={{
                        padding: '7px 14px', fontSize: '12px',
                        backgroundColor: COR.verde, color: COR.branco,
                        border: 'none', borderRadius: '4px',
                        cursor: salvandoPerm ? 'wait' : 'pointer',
                        opacity: salvandoPerm ? 0.6 : 1, fontWeight: '700',
                      }}>
                      {salvandoPerm ? 'Salvando...' : 'Salvar todas as rotinas'}
                    </button>
                  )}
                </div>

                {/* Conteúdo */}
                {carregandoCatalogo || carregandoPerm ? (
                  <div style={{ textAlign: 'center', padding: '40px', color: COR.muted, fontSize: '13px' }}>
                    Carregando rotinas...
                  </div>
                ) : rotinasVisiveis.length === 0 ? (
                  <div style={{ textAlign: 'center', padding: '40px', color: COR.muted, fontSize: '13px' }}>
                    Nenhuma rotina {filtroRotinas ? 'corresponde ao filtro' : 'cadastrada'}.
                  </div>
                ) : (
                  [...rotinasPorSecao.entries()].map(([secao, rs]) => (
                    // r133 itens 5, 7: cada grupo (Cadastros, Comercial...) é uma Secao
                    // expansível com ícone do menu antes do título.
                    <Secao
                      key={secao}
                      icone={iconeSecao(secao)}
                      titulo={tituloSecao(secao)}
                      aberta={gruposExpandidos.has(secao)}
                      onToggle={() => toggleGrupo(secao)}
                    >
                      {rs.map(r => {
                        const aninhado = r.codigo.startsWith('valores-');
                        return (
                          <div
                            key={r.codigo}
                            style={aninhado ? {
                              marginLeft: '22px',
                              borderLeft: `2px solid ${COR.borda}`,
                              paddingLeft: '10px',
                            } : undefined}
                          >
                            <RotinaCard
                              rotina={r}
                              aninhado={aninhado}
                              expandido={rotinasExpandidas.has(r.codigo)}
                              onToggle={() => toggleExpansaoRotina(r.codigo)}
                              getPerm={getPerm}
                              setPerm={setPerm}
                              setTodasAcoes={(p) => setTodasAcoesDaRotina(r.codigo, p)}
                              filtroAtual={getFiltroDaRotina(r.codigo)}
                              setFiltroRotina={(fc) => setFiltroDaRotina(r.codigo, fc)}
                              salvar={() => salvarPermissoesDaRotina(r.codigo)}
                              salvando={salvandoPerm}
                              somenteLeitura={somenteLeitura}
                            />
                          </div>
                        );
                      })}
                    </Secao>
                  ))
                )}
              </div>
            </Secao>
        </div>
      </Modal>
    </div>
  );
}

// ─── RotinaCard — card expansível por rotina (r84) ──────────────────────────
function RotinaCard({ rotina, aninhado, expandido, onToggle, getPerm, setPerm,
                     setTodasAcoes, filtroAtual, setFiltroRotina,
                     salvar, salvando, somenteLeitura }) {
  const totalAcoes  = rotina.acoes.length;
  const acoesAtivas = rotina.acoes.filter(a => getPerm(rotina.codigo, a.codigo).permitido).length;
  const todasAtivas = acoesAtivas === totalAcoes && totalAcoes > 0;
  const algumasAtivas = acoesAtivas > 0 && acoesAtivas < totalAcoes;

  return (
    <div style={{
      backgroundColor: COR.branco, border: `1px solid ${COR.borda}`,
      borderRadius: '6px', marginBottom: '6px', overflow: 'hidden',
    }}>
      {/* Cabeçalho clicável */}
      <div onClick={onToggle} style={{
        padding: '9px 12px', cursor: 'pointer',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        borderBottom: expandido ? `1px solid ${COR.borda}` : 'none',
        backgroundColor: expandido ? COR.azulBg : COR.branco,
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: 0 }}>
          {/* r133 item 6: chevron SVG no lugar de ▼/▶ */}
          <span style={{ display: 'inline-flex', color: COR.muted, flexShrink: 0 }}>
            <SvgChevron aberto={expandido} size={14} />
          </span>
          {/* r134 item 2: ícone SVG da rotina (mesmo do menu) antes do label */}
          <span style={{ display: 'inline-flex', color: expandido ? COR.azul : COR.muted, flexShrink: 0 }}>
            {iconeDaRotina(rotina.codigo, { width: 16, height: 16 })}
          </span>
          <span style={{ fontSize: '13px', fontWeight: '600', color: COR.texto }}>
            {aninhado && <span style={{ color: COR.muted, marginRight: '4px' }}>↳</span>}
            {rotina.label}
          </span>
          {/* r134 item 1: removida a duplicação do código da rotina (ex: "usuarios") */}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexShrink: 0 }}>
          {/* r133 item 9: pílula no padrão Colaborador (12/500, borda na cor) */}
          <span style={{
            display: 'inline-block', padding: '2px 10px',
            borderRadius: '20px', fontSize: '12px', fontWeight: '500',
            backgroundColor: todasAtivas ? COR.verdeBg : (algumasAtivas ? COR.amareloBg : '#f3f4f6'),
            color:           todasAtivas ? COR.verde  : (algumasAtivas ? COR.amarelo  : COR.muted),
            border: `1px solid ${todasAtivas ? COR.verde : (algumasAtivas ? COR.amarelo : COR.borda)}`,
          }}>
            {acoesAtivas}/{totalAcoes} ações
          </span>
          {filtroAtual && (
            <span title={`Filtro ativo: ${filtroAtual}`} style={{
              display: 'inline-block', padding: '2px 10px',
              borderRadius: '20px', fontSize: '12px', fontWeight: '500',
              color: COR.azul, backgroundColor: COR.azulBg,
              border: `1px solid ${COR.azul}`,
            }}>
              Filtro
            </span>
          )}
        </div>
      </div>

      {/* Detalhe expandido */}
      {expandido && (
        <div style={{ padding: '12px' }}>
          {/* Ações */}
          <div style={{ marginBottom: '12px' }}>
            <div style={{
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              marginBottom: '6px',
            }}>
              <strong style={{ fontSize: '11px', color: COR.texto }}>Ações</strong>
              {!somenteLeitura && (
                <div style={{ display: 'flex', gap: '5px' }}>
                  <button type="button"
                    onClick={() => setTodasAcoes(true)}
                    style={{
                      padding: '3px 8px', fontSize: '10px',
                      backgroundColor: COR.branco, color: COR.azul,
                      border: `1px solid ${COR.azul}`, borderRadius: '3px',
                      cursor: 'pointer',
                    }}>
                    Marcar tudo
                  </button>
                  <button type="button"
                    onClick={() => setTodasAcoes(false)}
                    style={{
                      padding: '3px 8px', fontSize: '10px',
                      backgroundColor: COR.branco, color: COR.muted,
                      border: `1px solid ${COR.borda}`, borderRadius: '3px',
                      cursor: 'pointer',
                    }}>
                    Desmarcar
                  </button>
                </div>
              )}
            </div>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
              gap: '5px',
            }}>
              {rotina.acoes.map(a => {
                const p = getPerm(rotina.codigo, a.codigo);
                return (
                  <label key={a.codigo} style={{
                    display: 'flex', alignItems: 'center', gap: '7px',
                    padding: '5px 8px', fontSize: '12px',
                    backgroundColor: p.permitido ? COR.verdeBg : '#fafafa',
                    border: `1px solid ${p.permitido ? COR.verde : COR.borda}`,
                    borderRadius: '4px',
                    cursor: somenteLeitura ? 'default' : 'pointer',
                  }}>
                    <input
                      type="checkbox" checked={!!p.permitido}
                      disabled={somenteLeitura}
                      onChange={e => setPerm(rotina.codigo, a.codigo, {
                        ...p, permitido: e.target.checked,
                      })}
                      style={{ accentColor: COR.azul }}
                    />
                    <span style={{ color: COR.texto }}>{a.label}</span>
                  </label>
                );
              })}
            </div>
          </div>

          {/* Filtro próprio (se a rotina declarar algum) */}
          {rotina.filtros_proprios?.length > 0 && (
            <div style={{ marginBottom: '10px' }}>
              <strong style={{ fontSize: '11px', color: COR.texto, display: 'block' }}>
                Filtro "apenas meus registros"
              </strong>
              <div style={{ fontSize: '10px', color: COR.muted, marginBottom: '5px' }}>
                Opcional. Se selecionado, o usuário só vê registros que correspondem.
              </div>
              <select
                value={filtroAtual || ''}
                onChange={e => setFiltroRotina(e.target.value || null)}
                disabled={somenteLeitura}
                style={{
                  width: '100%', maxWidth: '520px', height: '32px',
                  padding: '0 10px', fontSize: '11px',
                  border: `1px solid ${COR.borda}`, borderRadius: '4px',
                  backgroundColor: somenteLeitura ? '#fafafa' : COR.branco,
                  cursor: somenteLeitura ? 'default' : 'pointer',
                }}>
                <option value="">— Sem filtro (acesso total) —</option>
                {rotina.filtros_proprios.map(f => (
                  <option key={f.codigo} value={f.codigo}>
                    {f.label} · ({f.campo_tabela} {f.operador === 'EQ' ? '=' : 'IN'} {f.origem_valor === 'U' ? 'usuário' : 'colaborador'})
                  </option>
                ))}
              </select>
            </div>
          )}

          {/* Salvar */}
          {!somenteLeitura && (
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <button type="button" onClick={salvar} disabled={salvando} style={{
                padding: '6px 14px', fontSize: '11px',
                backgroundColor: COR.azul, color: COR.branco,
                border: 'none', borderRadius: '4px',
                cursor: salvando ? 'wait' : 'pointer',
                opacity: salvando ? 0.6 : 1, fontWeight: '600',
              }}>
                {salvando ? 'Salvando...' : 'Salvar esta rotina'}
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default GruposAcessoPage;
